module.exports = __webpack_public_path__ + "img/ico_service_arw_up.360b71f0.svg";